import { useEffect } from "react";
import { useAppSelector } from "../redux/hooks";
import { useScriptTag } from "@reactuses/core";
import { isProduction } from "../utils/getUrlPrefix";

declare global {
  interface Window {
    _mfq?: unknown[];
    _mfReady?: boolean;
  }
}

export const useMouseflowIdentify = () => {
  const { user_id, organization_id, organization_name, user_full_name } = useAppSelector((state) => state.user);
  // Only load Mouseflow script in production
  const [, status] = useScriptTag(
    isProduction ? "https://cdn.mouseflow.com/projects/2af85220-c5c6-4723-acb4-22a13f02a373.js" : "",
  );

  useEffect(() => {
    if (!isProduction || status !== "ready" || !user_id || !window._mfq) return;

    window._mfq.push(["setVariable", "User ID", user_id]);
    window._mfq.push(["setVariable", "User Name", user_full_name]);
    window._mfq.push(["setVariable", "Org ID", organization_id]);
    window._mfq.push(["setVariable", "Org Name", organization_name]);
  }, [status, user_id, user_full_name, organization_id, organization_name]);
};
